import * as moment from "moment";
import {InvoiceApprovedEventDataApiDto, InvoiceEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InvoiceEvent, {InvoiceEventTypeEnum} from "./InvoiceEvent";
import {none, option, Option} from "ts-option";

/**
 * Invoice approved event model.
 */
export default class InvoiceApprovedEvent extends InvoiceEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {InvoiceEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} creator entity which created the event.
	 * @param {moment.Moment} creationDateTime creation date of event.
	 * @param {InvoiceApprovedEventData} data approved invoice created event data.
	 */
	constructor(public readonly id: string,
		public readonly type: InvoiceEventTypeEnum,
		public readonly creator: AuthenticatedEntity,
		public readonly creationDateTime: moment.Moment,
		public readonly data: InvoiceApprovedEventData) {
		super(id, type, creator, creationDateTime);
	}

	public static fromJson(json: InvoiceEventApiDto): InvoiceApprovedEvent {
		const data = InvoiceApprovedEventData.fromJson(json.data as InvoiceApprovedEventDataApiDto);
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new InvoiceApprovedEvent(json.id, InvoiceEventTypeEnum.InvoiceApproved, creator, moment(json.creationDateTime),
			data);
	}

	getIcon() {
		return Icon.New;
	}

	getActivityType(): string {
		return `INVOICE APPROVED`;
	}

	getActivityMessage(): string {
		return `Invoice has been approved`
	}
}

export class InvoiceApprovedEventData {
	constructor(public readonly invoiceNo: Option<string>,
		public readonly dueDate: Option<moment.Moment>,
	) {}

	public static fromJson(json: InvoiceApprovedEventDataApiDto): InvoiceApprovedEventData {
		return new InvoiceApprovedEventData(option(json.invoiceNo), json.dueDate ? option(moment(json.dueDate)) : none);
	}
}
